module.exports = __webpack_public_path__ + "static/media/self2.5b8a5725.webp";